<template>
  <footer class="footer py-5 mt-4 fixed-bottom">
    <div class="container">
      <div class="row scrollbar">
        <ul class="product-list col-md-12">
          <li
            class="d-flex flex-row justify-content-between "
            v-for="item in getCart.items"
            :key="item.product.id"
          >
            <span>
              {{ item.product.name }}
            </span>

            <span>
              {{ item.quantity }} x R$
              {{ parseFloat(item.product.price).toFixed(2) }}</span
            >
          </li>
          ``
        </ul>
      </div>
    </div>

    <div class="container"></div>
    <div class="order-box container col-md-10">
      <div class="total-price col-md-12 mt-4">
        <span>TOTAL: </span>
        <span class="float-right">R$ {{ getCart.amount.toFixed(2) }}</span>
      </div>
      <div class="button-footer mt-4 col-md-12">
        <router-link to="/"
          ><a href="#" class="cancel-order"
            >CANCELAR PEDIDO <i class="fas fa-times-circle"></i
          ></a>
        </router-link>
        <a href="#" @click="finishOrder" class="confirm-order"
          >CONFIRMAR PEDIDO
          <i class="fas fa-check-circle"></i>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import signalRFactory, {
    CARD_ERROR_READ,
    CARD_READ,
  } from "../../signal-r-factory.js";
  import printer from "../../resources/printer";

  export default {
    name: "CartFooter",
    computed: {
      ...mapGetters({
        getCart: "getCart",
        getOrder: "getOrder",
        getAccount: "getAccount",
      }),
    },
    data() {
      return {
        waitingCard: false,
        signalR: null,
      };
    },
    async mounted() {
      let self = this;
      if (this.getCart.dotNotHaveItems) {
        await this.$router.push({ name: "products" });
      }

      const swalWaitingConnection = this.$swal({
        title: "Aguardando conexão...",
        type: "info",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          self.$swal.showLoading();
        },
      });

      this.waitingCard = false;
      this.signalR = await signalRFactory();
      let tries = 10;
      while (!this.signalR && tries > 0) {
        setTimeout(async () => {
          this.signalR = await signalRFactory();
          tries--;
        }, 1000);
      }
      swalWaitingConnection.close();
      if (!!this.signalR) {
        this.signalR.on(CARD_READ, await this.onCardRead);
        this.signalR.on(CARD_ERROR_READ, await this.onCardError);
        return false;
      }

      this.$swal({
        title:
          "Não foi posssível detectar o sensor de cartão, por favor, reinicie a aplicação!",
        type: "error",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        showConfirmButton: false,
        allowOutsideClick: false,
        cancelButtonText: "Reiniciar",
        onOpen: () => {
          this.waitingCard = true;
        },
        onClose: () => {
          this.waitingCard = false;
          this.$router.push({ name: "standby" });
          window.location.reload();
        },
      });
    },

    async beforeDestroy() {
      this.signalR.off(CARD_READ);
      this.signalR.off(CARD_ERROR_READ);
    },

    methods: {
      ...mapActions({ _finishOrder: "finishOrder" }),
      async finishOrder() {
        this.waitingCard = true;

        this.$swal({
          title: "Passe o cartão novamente para confirmar a compra",
          type: "info",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          showConfirmButton: false,
          cancelButtonText: "Cancelar",
          allowOutsideClick: false,
          onOpen: () => {
            this.waitingCard = true;
          },
          onClose: () => {
            this.waitingCard = false;
          },
        });
      },

      async onCardError() {
        if (this.waitingCard === false) {
          return;
        }

        this.$swal({
          title: "Não foi posssível ler o cartão, passe novamente",
          type: "error",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          showConfirmButton: false,
          allowOutsideClick: false,
          onOpen: () => {
            this.waitingCard = true;
          },
          onClose: () => {
            this.waitingCard = false;
          },
        });
      },

      async onCardRead(uuid) {
        try {
          if (this.waitingCard === false) {
            return;
          }
          this.waitingCard = false;

          await this._finishOrder(uuid);

          //   this.$swal({
          //     title: `Compra aprovada!`,
          //     type: "success",
          //     showCancelButton: false,
          //     showConfirmButton: false,
          //     allowOutsideClick: false,
          //   });

          const order = this.getOrder;

          // await printer.print({
          //     'CustomerName': order.customer_name,
          //     'CompanyName': order.company_name,
          //     'Amount': order.amount,
          //     'Products': order.products,
          //     'Date': order.date,
          // });

          await this.$swal({
            title: `Compra aprovada! Obrigado ${this.getAccount.dependent.name} e até mais 😉.`,
            type: "success",
            timer: 3000,
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          await this.$router.push({ name: "standby" });
        } catch (e) {
          console.log(e);
          console.log(e.response);
          await this.$swal({
            title: `Oops...${e.response.data.message}`,
            type: "error",
            timer: 3000,
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
          });
        }
      },
    },
  };
</script>

<style scoped>
  .footer {
    background-color: var(--dark-orange);
    padding-top: 15px;
  }

  .product-list {
    list-style-type: none;
  }

  .product-list > li {
    color: #fff;
    font-size: 20px;
    border-bottom: #fff dashed 1px;
  }

  .order-box {
    margin: auto;
  }

  .total-price {
    background-color: #fff;
    border-radius: 10px;
    font-size: 35px;
    font-weight: bold;
    color: var(--dark-orange);
    margin: auto;
  }

  .cancel-order {
    color: #fff;
    text-decoration: none !important;
    float: left;
    font-weight: bold;
    font-size: 23px;
  }

  .confirm-order:hover,
  .cancel-order:hover {
    letter-spacing: 1px;
    box-shadow: 5px 40px -10px rgba(0, 0, 0, 0.57);
    transition: all 0.4s ease 0s;
    color: #fff;
  }

  .cancel-order i {
    color: var(--light-orange);
    font-size: 30px;
  }

  .confirm-order {
    color: #fff;
    text-decoration: none !important;
    float: right;
    font-weight: bold;
    font-size: 23px;
  }

  .confirm-order i {
    color: var(--light-orange);
    font-size: 30px;
  }
</style>
